import React from 'react';
import { Button,  Modal } from "react-bootstrap";
import styled from "styled-components";
import { WerfenColor, WerfenColorContrast, White } from "../../../../Constants/ColorChart";


const StyledModal = styled ( Modal )`
    & .modal-dialog.modal-lg{
        max-width: 1200px;
    }
`

const StyledModalHeader = styled ( Modal.Header )`
    & .close{
        border: 0 none transparent;
        background: ${ White };
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 15px;
        top: 10px;
        width: 40px;
        height: 40px;
        opacity: 0.5;
        &:hover {
            opacity: 1;
        }
        & .sr-only {
            display: none;
        }
    }
`
const StyledModalBody = styled ( Modal.Body )`
    label {
        padding-top: 16px;
    }  
`

const StyledSubmit = styled ( Button )`
    background: ${ WerfenColorContrast }!important;
    color: ${ White };
    border-radius: 0!important;
    border: 0 none transparent!important;
    outline: 0 none transparent!important;
    boxShadow: unset!important;
    margin-top: 20px;
`

const StyledCancel= styled ( Button )`
    background: ${ WerfenColor }!important;
    color: ${ White };
    border-radius: 0!important;
    border: 0 none transparent!important;
    outline: 0 none transparent!important;
    boxShadow: unset!important;
    margin-top: 20px;
`

const ConfirmationDialog = ( props ) => {
    return (
        <StyledModal
            show={ props.show }
            onHide={ props.onHide }
        >
             <StyledModalHeader closeButton>
                <Modal.Title>{ props.title }</Modal.Title>
            </StyledModalHeader>
            <StyledModalBody>{ props.messageArray.map ( ( line, index ) => {
                return (
                    <p key={ index }>{ line }</p>
                )
            } ) }</StyledModalBody>
            <Modal.Footer>

                 <StyledCancel variant="secondary" onClick={ props.handleOnCancel }>
                    { props.labelCancel }
                </StyledCancel>
                <StyledSubmit
                    variant="primary"
                    onClick={ props.handleOnAccept }>
                    { props.labelAccept }
                </StyledSubmit>
            </Modal.Footer>
        </StyledModal>
    );
};
export default ConfirmationDialog;
